import React, { useState } from 'react';
import { axiosInstance } from '../../../utils';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import eye from "../../../assets/svgs/eye.svg";
import eye_slash from "../../../assets/svgs/eye_slash.svg";

const AddAdmin = () => {
    const [registerAdmin, setRegisterAdmin] = useState({
        firstname: "",
        lastname: "",
        email: "",
        userId: "",
        contact: "",
        password: "",
        isValidEmail: "",
        isValidPassword: "",
        isValidUserId: "",
      });
     const [showPassword, setShowPassword] = useState(false);

    
      const navigate = useNavigate();

      const handleShowPassword = () => {
        setShowPassword(prev => !prev);
      }

      const handleRegisterAdminChange = (e) => {
        const { name, value } = e.target;
        setRegisterAdmin(prevValues => ({...prevValues, [name]: value}))
      } 
    
      const handleFirstNameChange = (e) => {
        const value = e.target.value;
        const regex = /^[a-zA-Z\s]+$/;
        if (value.match(regex) || value === "") {
          setRegisterAdmin(prevValues => ({
            ...prevValues,
            firstname: value
          }))  
        }
      }
    
      const handleLastNameChange = (e) => {
        const value = e.target.value;
        const regex = /^[a-zA-Z\s]+$/;
        if (value.match(regex) || value === "") {
          setRegisterAdmin(prevValues => ({
            ...prevValues,
            lastname: value
          }))  
        }
      }
    
      const handleContactChange = (e) => {
        const value = e.target.value;
        const regex = /^[0-9]+$/;
        if (value.match(regex) || value === "") {
          setRegisterAdmin(prevValues => ({
            ...prevValues,
            contact: value
          }))  
        }
      }
    
      const handlePasswordChange = (e) => {
        const value = e.target.value;
        // const regex = /^[a-zA-Z0-9(\$*@)]+$/;
        const passwordRegex = /^(?=.*[A-Z])(?=.*[$*@])(?=.*\d).{8,10}$/;
        const isValidPassword = value.match(passwordRegex) || value === "";

       
          setRegisterAdmin(prevValues => ({
            ...prevValues,
            password: value,
            isValidPassword: isValidPassword
          }))  
        
      }

      const handleEmailChange = (e) => {
        const value = e.target.value;
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const isValidEmail = value.match(emailRegex) || value === "";
        
          setRegisterAdmin(prevValues => ({
            ...prevValues,
            email: value,
            isValidEmail: isValidEmail,
          }))  
        
      }
    
    
      const handleUserIdChange = (e) => {
        const value = e.target.value;
        const userIdRegex = /^[a-z0-9]{5,20}$/;
        const isValidUserId = value.match(userIdRegex) || value === "";

          setRegisterAdmin(prevValues => ({
            ...prevValues,
            userId: value,
            isValidUserId: isValidUserId
          }))  
      }
      
        const token = localStorage?.getItem("token");
    
    const redirectFn = () => {
      const redirectTimer = setTimeout(() => {
        navigate("/dashboard/user-management/admin");  
      }, 2000);

      return redirectTimer;
    }

     const handleAddNewAdmin = async (e) => {
      const { firstname, lastname, email, userId, password, contact } = registerAdmin;
      if (!registerAdmin.isValidPassword) {
        toast.error("Please enter a Password which contains 1 Captical letter, 1 symbol, 1 number, min 8 letters, max 10 letters", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        });
        return; 
      }
      if (!registerAdmin.isValidUserId) {
        toast.error("Please enter a user id with limit of 5 min and 20 max including numbers & letters.", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        });
        return; 
      }
      if (!registerAdmin.isValidEmail) {
        toast.error("Please enter a valid email address", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        });
        return; 
      }
       if(!firstname) {
        toast.error("Please, Enter Your First Name",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
       } else if(!lastname) {
        toast.error("Please, Enter Your Last Name",
            {
              position: "top-right",
              autoClose: 5000,
              theme: "light",
              hideProgressBar: true,
            }
          );
       } else if(!email){
        toast.error("Please, Enter Your Email",
            {
              position: "top-right",
              autoClose: 5000,
              theme: "light",
              hideProgressBar: true,
            }
          );
       } else if(!userId) {
        toast.error("Please, Enter User ID",
            {
              position: "top-right",
              autoClose: 5000,
              theme: "light",
              hideProgressBar: true,
            }
          );
       } else if(!contact) {
        toast.error("Please, Enter Your Contact Number",
            {
              position: "top-right",
              autoClose: 5000,
              theme: "light",
              hideProgressBar: true,
            }
          );
       } else if(!password) {
        toast.error("Please, Enter Password",
            {
              position: "top-right",
              autoClose: 5000,
              theme: "light",
              hideProgressBar: true,
            }
          );
       } else if(!firstname && !lastname && !email && !contact && !userId && !password) {
        toast.error("Please, Fill Out Fields",
            {
              position: "top-right",
              autoClose: 5000,
              theme: "light",
              hideProgressBar: true,
            }
          );
       } else {
    
      e.preventDefault();
      let data = {
        firstName: registerAdmin.firstname,
        lastName: registerAdmin.lastname,
        email: registerAdmin.email,
        userId: registerAdmin.userId,
        contactNumber: registerAdmin.contact,
        password: registerAdmin.password
      }
      console.log(data);
      await axiosInstance.post("/api/admin/register-dashboard-user", data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(res => {
        toast.success(res.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });
         redirectFn();
      })
      .catch(err => { 
        toast.error(err.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });
      } )
    }
     } 
     
    const clear = () => {
        setRegisterAdmin({
            firstname: "",
            lastname: "",
            contact: "",
            email: "",
            password: "",
            userId: ""
        })
    }

  return (
    <section className='container py-10'>
         <h1 className='heading-one !text-center !pb-3'>Add New Admin</h1>
          <div className='bg-white rounded-md p-4  border-t-8 border-t-primary-yellow-500 max-w-min mx-auto'>
         <div className=''>
          <div className='lg:space-y-3 md:space-y-2 sm:space-y-2 space-y-2'>
            {/* <div className='flex gap-2 lg:flex-row md:flex-col sm:flex-col flex-col'> */}
              <div className='flex flex-col gap-1'>
                <label htmlFor='firstname' className='font-poopins text-sm font-medium text-secondary-n-200'>First Name</label>
                <input type='text' name='firstname' value={registerAdmin.firstname} onChange={handleFirstNameChange} placeholder='First Name' className='outline-none pl-3 rounded-md lg:w-full md:w-full sm:w-full w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
              <div className='flex flex-col gap-1'>
                <label htmlFor='lastname' className='font-poopins text-sm font-medium text-secondary-n-200'>Last Name</label>
                <input type='text' name='lastname' value={registerAdmin.lastname} onChange={handleLastNameChange} placeholder='Last Name' className='outline-none pl-3 rounded-md lg:w-full md:w-full sm:w-full w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
            {/* </div> */}
            <div className='flex flex-col gap-1'>
                <label htmlFor='email' className='font-poopins text-sm font-medium text-secondary-n-200'>Email</label>
                <input type='email' name='email' value={registerAdmin.email}  onChange={handleEmailChange} placeholder='Email' className='outline-none pl-3 rounded-md w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
              <div className='flex flex-col gap-1'>
                <label htmlFor='userid' className='font-poopins text-sm font-medium text-secondary-n-200'>User ID</label>
                <input type='text' name='userId' value={registerAdmin.userId} onChange={handleUserIdChange} placeholder='User ID' className='outline-none pl-3 rounded-md w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
              <div className='flex flex-col gap-1'>
                <label htmlFor='contact number' className='font-poopins text-sm font-medium text-secondary-n-200'>Contact Number</label>
                <input type='tel' name='contact' value={registerAdmin.contact} onChange={handleContactChange} minLength={10} maxLength={10} placeholder='Enter your Number' className='outline-none pl-3 rounded-md w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
              <div className='flex flex-col gap-1'>
                <label htmlFor='password' className='font-poopins text-sm font-medium text-secondary-n-200'>Password</label>
                <div className="relative">
              <input type={`${ showPassword ? "text" : "password"}`} 
              name="password" 
              value={registerAdmin.password} 
              onChange={handlePasswordChange} placeholder="Enter your Password" 
              className='outline-none pl-3 rounded-md w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' 
               />
          <div className="absolute top-2 sm:top-3 lg:top-3 right-2 sm:right-6 lg:right-6">
            { showPassword ? (
              <img src={eye_slash}  className="text-secondary-n-90" onClick={handleShowPassword} alt="eye_slash icon" />
              ) : (
                <img src={eye} onClick={handleShowPassword} alt="eye icon" />
            ) }
          </div>
          </div>
              
              </div>
              <div className='flex items-center gap-2'>
                <button className='font-poppins h-10 w-[250px] text-secondary-n-90 outline-none bg-white border-[1px] border-secondary-n-90 flex justify-center items-center rounded-md' onClick={clear}>Clear</button>
                <button className='font-poppins h-10 w-[250px] text-white outline-none bg-primary-yellow-500 flex justify-center items-center rounded-md' onClick={handleAddNewAdmin}>Add</button>
              </div>
          </div>
         </div>
        
          <ToastContainer />
        </div>
    </section>
  )
}

export default AddAdmin